// extracted by mini-css-extract-plugin
module.exports = {"root":"MedicalHistory_root__1j2df"};